module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-2.a271e17d.jpg";